<template>
  <div id="catalogBundles" class="bundles mb-4">
    <div class="flex items-center text-xl text-pdsPrimaryColor mb-2">
      <span class="text-xl text-pdsPrimaryColor mb-2">Bundels</span>
      <div v-if="bundles.length > 2" class="self-start">
        <ChevronDownIcon
          @click.prevent="toggleDetails()"
          v-if="bundles.length > 2 && !collapsed"
          class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor"
          aria-hidden="true"
        />
        <ChevronUpIcon
          @click.prevent="toggleDetails()"
          v-else-if="bundles.length > 2"
          class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor"
          aria-hidden="true"
        />
      </div>
    </div>
    <transition-group
      class="grid grid-rows md:grid-rows md:grid-cols-2 gap-2 mb-2"
      tag="ul"
      name="transition-up-down"
      v-if="!collapsed"
    >
      <v-bundle v-for="bundle in bundles" :key="bundle.illnessBundleId" :bundle="bundle" class="flex-1 my-2" />
    </transition-group>
  </div>
</template>

<script>
import VBundle from './Bundle';
import { ref } from 'vue';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/20/solid';
import { useResponsiveCollapse } from '@/composables/useResponsiveCollapse';

export default {
  name: 'Bundles',
  components: {
    VBundle,
    ChevronDownIcon,
    ChevronUpIcon
  },
  props: {
    bundles: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const { collapsed } = useResponsiveCollapse();

    const toggleDetails = () => {
      collapsed.value = !collapsed.value;
    };

    return {
      collapsed,
      toggleDetails
    };
  }
};
</script>
